var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRIncrementGraphIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 33,
    viewBox: "0 0 73 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.2169L10.8447 19.1205L13.4354 11.0241L35.7154 4.46988L39.8606 19.1205L53.3322 17.5783L65.7676 9.86747L72.5034 1",
    stroke: "#049E16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2621 4.85542L13.9103 11.0241L11.4276 19.1205L1 27.6024V33H72.5034L73 1L66.0483 10.253L53.6345 17.9639L39.731 19.506L35.2621 4.85542Z",
    fill: "url(#paint0_linear_286_4505)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_286_4505",
    x1: 36.7517,
    y1: 41.4819,
    x2: 36.7517,
    y2: 6.01205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCFDD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRIncrementGraphIcon);
export default __webpack_public_path__ + "static/media/r-increment-graph-icon.73b0a233763aa1cc12961fa97e775c86.svg";
export { ForwardRef as ReactComponent };